<div class="datetime-picker-container" [class.datetime-picker-disabled]="disabled">
  <div class="datetime-picker-date">
    <app-date-picker
      [formControl]="dateFormControl"
      [name]="name"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [displayFormat]="dateDisplayFormat"
      [dateFormat]="dateFormat"
      [showResetButton]="false"
      [showClearButton]="false"
      [dateRange]="false"
      [inline]="false"
      [disableUntil]="internalDisableUntil"
      [disableSince]="internalDisableSince"
      [appendSelectorToBody]="true">
    </app-date-picker>
  </div>

  <div class="datetime-picker-time">
    <app-time-picker
      [formControl]="timeFormControl"
      [stepMinutes]="timeStepMinutes"
      [disabledTimes]="disabledTimesForSelectedDate">
    </app-time-picker>
  </div>

  <div
    class="datetime-picker-clear"
    *ngIf="showClearButton && (dateFormControl.value || timeFormControl.value)"
  >
    <span class="fal fa-fw fa-times" (click)="onClearClicked()"></span>
  </div>
</div>
